<div class="header">
  <h2>{{'SETTINGS.TITLE' | translate}}</h2>
</div>

<div class="m-t-20 form-center border">
  <h4>{{'SETTINGS.AUTOSEND-HEADER' | translate}}</h4>
  <br/>
  <div class="form-group row">
    <div class="col-sm-11">
      <input type="radio" class="autoSendSetting" value="autoSend" [(ngModel)]="selectedValue" (change)="onItemChange()"/><label class="settingsRadioButtonLabel">{{'SETTINGS.AUTOSEND' | translate}}</label>
      <br/>
      <br/>
      <label class="col-form-label">{{'SETTINGS.AUTOSEND-SENTENCE' | translate}}</label>
      <hr>
    </div>
    <div class="col-sm-11">
      <input type="radio" class="autoSendSetting" value="manualSend" [(ngModel)]="selectedValue" (change)="onItemChange()"/><label class="settingsRadioButtonLabel">{{'SETTINGS.MANUALSEND' | translate}}</label>
      <br/>
      <br/>
      <label>{{'SETTINGS.MANUALSEND-SENTENCE-1' | translate}}</label>
      <br/>
      <label>{{'SETTINGS.MANUALSEND-SENTENCE-2a' | translate}}</label>
      <select id="manualSendDaySelectBox" class="form-control language-switcher" style="width: auto;display: inline" [(ngModel)]="manualSendDay">
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
        <option value="13">13</option>
        <option value="14">14</option>
        <option value="15">15</option>
      </select>
      <label>{{'SETTINGS.MANUALSEND-SENTENCE-2b' | translate}}</label>
      <label>{{'SETTINGS.MANUALSEND-SENTENCE-3' | translate}}</label>
    </div>
  </div>
</div>
<br/>
<br/>
<div class="text-right">
  <button class="btn btn-primary" (click)="save(content)">{{'SETTINGS.SAVE' | translate}}</button>
  <button class="btn btn-primary" (click)="cancel()" >{{'COMMON.CANCEL' | translate}}</button>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeConfirmSettingsBox()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <span style="color: #4d5f7a">{{'SETTINGS.CONFIRM-SETTINGS' | translate}}?</span>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary btn-wide" (click)="confirmSaveSettingsBox(content2)">{{'COMMON.YES' | translate}}</button>
    <button type="button" class="btn btn-primary btn-wide" (click)="closeConfirmSettingsBox()">{{'COMMON.NO' | translate}}</button>
  </div>
</ng-template>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closePasswordBox()">
    <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <label class="text-center">{{'SETTINGS.ENTER-PASSWORD' | translate}}</label>
        <input type="password" class="form-control px-2 text-center" [(ngModel)]="confirmPassword" #passwordInput />
        {{ passwordInput.focus() }}
        <p class="text-red" *ngIf="passwordErrorMessage">{{passwordErrorMessage}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary btn-wide" (click)="enterPasswordBox(content3)">{{'COMMON.OK' | translate}}</button>
    <button type="button" class="btn btn-primary btn-wide" (click)="closePasswordBox()">{{'COMMON.CANCEL' | translate}}</button>
  </div>
</ng-template>

<ng-template #content3 let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeSavedSuccessfullyBox()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
<!--        <span style="color: #4d5f7a">{{'SETTINGS.SAVED-SUCCESSFULLY' | translate}}!</span>-->
        <span style="color: #4d5f7a">{{this.updateSettingsMessage}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary btn-wide" (click)="closeConfirmSettingsBox()">{{'COMMON.OK' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.component.html